module.exports = __webpack_public_path__ + "assets/img/Infographics_img.f0da41c3.jpg";